export default __webpack_public_path__ + "static/media/Humanist521BoldBT.73c5121d.ttf";